import { listProducts, listProductsByMeilisearch } from "@/lib/data/products";
import { MeilisearchProductsList } from "./MeilisearchProductsList";
import { getSalesChannels } from "@/lib/data/sales-channes";
import { Gtag } from "@/components/molecules/Gtag/Gtag";
import Analytics from "@/components/molecules/Analytics/Analytics";
import { meilisearchFilterBuilder } from "@/lib/meilisearch-utils";
import { Track } from "@/components/molecules/Track/Track";
const PAGE_SIZE = 36;

export const MeilisearchProductsListing = async ({
  category_id,
  collection_id,
  seller_handle = process.env.NEXT_PUBLIC_SELLER_HANDLE,
  locale = process.env.NEXT_PUBLIC_DEFAULT_REGION,
  currency_code,
  searchParams
}: {
  category_id?: string
  collection_id?: string
  locale?: string
  seller_handle?: string
  currency_code?: string
  searchParams: any
}) => {

  let { page, query, sortBy } = searchParams
  page = page || 1;
  query = query || ""

  let filter = await meilisearchFilterBuilder({
    locale: locale!,
    seller_handle,
    category_id,
    collection_id,
    currency_code: currency_code!,
    searchParams
  })

  let listResult;
  let meiliResult;
  try {
    meiliResult = await listProductsByMeilisearch({
      query,
      sort: sortBy ? [sortBy] : ["sales:desc"],
      filter: filter,
      limit: PAGE_SIZE,
      offset: (page - 1) * PAGE_SIZE
    })

    if (meiliResult.estimatedTotalHits > 0) {
      listResult = await listProducts({
        countryCode: locale,
        queryParams: {
          fields:
            "*variants.calculated_price,*seller.reviews,-thumbnail,-images,-type,-tags,-variants.options,-options,-collection,-collection_id",
          id: meiliResult.hits.map(v => v.id),
          limit: PAGE_SIZE
        },
      })
    }
  } catch (error) {
    console.error("search error", error);
  }

  return (
    <>
      <Track event="view_item_list" data={{
        currency: currency_code,
        item_list_id: collection_id,
        items: listResult?.response.products.map(p => ({
          item_id: p.variants?.[0]?.sku,
          item_name: p.title,
          price: p.variants?.[0]?.calculated_price?.calculated_amount
        }))
      }} />
      <Analytics
        event="view_item_list"
        data={{
          currency: currency_code,
          item_list_id: collection_id,
          items: listResult?.response.products.map(p => ({
            item_id: p.variants?.[0]?.sku,
            item_name: p.title,
            price: p.variants?.[0]?.calculated_price?.calculated_amount
          }))
        }}
      />
      <MeilisearchProductsList locale={locale!} products={listResult?.response.products || []} meiliProducts={meiliResult?.hits || []} count={meiliResult?.estimatedTotalHits || 0} />
    </>
  )
}